import type { UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';
import type { MfaSettingsModel } from '@hotjar/webapp/domains/mfa/model';
import { getMfaSettings } from '@hotjar/webapp/domains/mfa/api';
import type { AxiosError } from 'axios';

const MFA_SETTINGS_QUERY_KEY = 'MFA_SETTINGS_QUERY_KEY';

export const useMfaSettings = (userId?: number): UseQueryResult<MfaSettingsModel, AxiosError> => {
  return useQuery<unknown, AxiosError, MfaSettingsModel>({
    queryKey: [MFA_SETTINGS_QUERY_KEY, userId],
    queryFn: () => {
      if (userId) {
        return getMfaSettings(userId);
      }
      return null;
    },
    retry: 2,
  });
};
